import React from 'react'
import { Row, Col, Image, Container } from 'react-bootstrap'
import cameras from '../../assets/cameras.webp'
import phone from '../../assets/yellow-blue-phone.webp'
import png from '../../assets/20-off.webp'
import { Link } from 'react-router-dom'

const Discounts = () => {
  return (
  <Container fluid>

    <Row className='mt-5 gy-4'>
      <Col lg={4} sm={12} >
        <div className='discount-col-first p-5 text-light'>
          <div  className='position-relative h-100 border border-3 border-light'>
            <h3 className='p-2 mt-4 display-2'>
              Smart Phones & Tablets
            </h3>
            <Link className='p-3 text-light fs-4 h-t-black' to="">See more</Link>
            <Image style={{height:"140px", bottom:"0", right:"0", paddingBottom:"20px", paddingRight: "20px"}} className=' position-absolute ' src={png} alt="20% off"/>

          </div>

        </div>

      </Col>
      <Col lg={8} sm={12}>
        <div className='discount-col-second p-5 text-light'>
          <div className='position-relative h-100 border border-3 border-light'>
            <h3 className='p-2 mt-4 display-2'>
              Cameras & Professional Filming Equipment 
            </h3>
            <Link className='p-3 text-light fs-4 h-t-turquoise' to="">See more</Link>
          </div>
        </div>
      </Col>
    </Row>
  </Container>
  )
}

export default Discounts